export const capitalizeAndRemoveUnderscore = (title) => `${title[0]?.toUpperCase() + title?.slice(1)?.replace('_', ' ')} `;
